import store from '../store/';

export default function can(action, entity) {
  let index = store.state.allPermissions.indexOf(`can_${action}_${entity}`);
  return index < 0 ? false : true;
}
